<template>
  <div class="main">
    <div class="main-item">
      <div class="item-left">
        <div class="item-name">
          <img src="../assets/jrcp.png" />
          <div>浏览金融产品</div>
        </div>
        <span>提供稳定的多项产品服务</span>
          <a target="_blank" @click="jumpOutLink('/product')">
            <div class="item-botton">立即前往 </div>
          </a>
      </div>
      <div class="item-right">
          <img src="../assets/jxbf2.png"/>
      </div>
    </div>
    <div class="main-item fqrz-item">
      <div class="item-left">
        <div class="item-name">
          <img src="../assets/fqrz.png" />
          <div>发起融资申请</div>
        </div>
        <a target="_blank" @click="jumpOutLink('/financing-apply')">
          <div class="item-botton">立即申请 </div>
        </a>
      </div>
      <div class="item-right">
          <img src="../assets/jxbf.png"/>
      </div>
    </div>
  </div>
</template>

<script>
import {jumpOutLink} from '@/util/common.js'

export default {
  data() {
    return {
      baseTargetUrl: require('../constants').JUMP_TARGET
    }
  },
  methods: {
    jumpOutLink(path, query) {
      const target = jumpOutLink(path, query)
      window.open(target)
    }
  }
};
</script>

<style scoped>
.main {
  width: 49%;
  margin-top: 5px;
}
.main-item {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  height: 187px;
  background-color: #f6fbff;
  margin-bottom: 20px;
  padding: 30px 30px 0px 20px;
  border: 1px solid #EDF0F3;
  border-radius: 4px;
  overflow: hidden;
}

.item-left span {
  display: block;
  color: #999999;
  font-size: 16px;
  margin-left: 40px;
}

.item-name {
  display: flex;
  margin-bottom: 15px;
}
.item-name img {
  width: 36px;
  height: 36px;
}
.item-name div {
  line-height: 36px;
  font-size: 24px;
  margin-left: 2px;
  color: #444444;
  font-weight: 500;
}
.item-botton {
  box-sizing: border-box;
  display: inline-block;
  font-size: 16px;
  width: 100px;
  padding-left: 8px;
  text-align: center;
  line-height: 32px;
  background-color: #1492ff;
  border-radius: 5px;
  color: #ffffff;
  font-family: PingFangSC-Regular, PingFang SC;
  margin-top: 25px;
  margin-left: 40px;
  cursor:pointer
}
.item-botton::after{
  content: url('../assets/jt.png');
  position: relative;
  top: 2px;
  left: -5px;
  width: 4px;
  height: 8px;
}
.item-botton:hover {
    opacity: 0.7;
}
.item-botton:active {
    opacity: 0.6;
}

.item-right img{
    height: 140px;
    width: 190px;
}

.fqrz-item{
    background-color:rgba(255,143,31,0.05);
}
.fqrz-item .item-botton {
    background-color: #FF8F1F;
}
</style>